module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p13-32532ae762414f0a5b03987f39f77f45.png";